export default "__VITE_ASSET__XMDJ8nPG__"